import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/brand.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Dynamic manifest + apple-touch-icon injection for role-specific PWAs.
// Each route gets its own manifest and iOS icon so it installs as a
// separate app with distinct name, icon, and start_url.
const roleConfig = {
  '/candidate':      { manifest: '/manifest-candidate.json', icon: '/brand/vouch/assets/raster/app-icon-candidate-180.png', title: 'Find Jobs' },
  '/voucher':        { manifest: '/manifest-voucher.json',   icon: '/brand/vouch/assets/raster/app-icon-voucher-180.png',   title: 'Vouch' },
  '/hiring-manager': { manifest: '/manifest-hm.json',        icon: '/brand/vouch/assets/raster/app-icon-hm-180.png',        title: 'Find People' },
  '/admin':          { manifest: '/manifest-admin.json',      icon: '/brand/vouch/assets/raster/app-icon-admin-180.png',     title: 'Admin' },
};
const cfg = roleConfig[window.location.pathname] || {
  manifest: '/manifest.json',
  icon: '/brand/vouch/assets/raster/app-icon-180.png',
  title: 'VOUCH',
};
// Manifest (Android / Chrome)
const manifestLink = document.createElement('link');
manifestLink.rel = 'manifest';
manifestLink.href = cfg.manifest;
document.head.appendChild(manifestLink);
// Apple touch icon (iOS home screen)
const touchIcon = document.createElement('link');
touchIcon.rel = 'apple-touch-icon';
touchIcon.href = cfg.icon;
document.head.appendChild(touchIcon);
// Apple web app title (iOS home screen label)
const appTitle = document.createElement('meta');
appTitle.name = 'apple-mobile-web-app-title';
appTitle.content = cfg.title;
document.head.appendChild(appTitle);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Unregister service worker to clear stale caches from previous deployments.
// Re-enable with serviceWorkerRegistration.register() once caches are cleared.
serviceWorkerRegistration.unregister();
